import { render, staticRenderFns } from "./block-organization-periods.vue?vue&type=template&id=dc763634&scoped=true&lang=pug"
import script from "./block-organization-periods.vue?vue&type=script&lang=js"
export * from "./block-organization-periods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc763634",
  null
  
)

export default component.exports